/**
 * @generated SignedSource<<0d11b4a09ce3abe32fcc8a6cd5361bbf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_displayInfo$data = {
  readonly ctas: {
    readonly showAcceptOffer: boolean | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespMarketplaceStickyHeader_displayInfo" | "PdpRespSidebarBlurbs_displayInfo" | "PdpRespSidebarButtons_displayInfo" | "PdpSharedPromoCode_displayInfo">;
  readonly " $fragmentType": "PdpRespContainer_displayInfo";
};
export type PdpRespContainer_displayInfo$key = {
  readonly " $data"?: PdpRespContainer_displayInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespContainer_displayInfo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isPDPDesktopAggregationVariant"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespContainer_displayInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "CTADisplay",
      "kind": "LinkedField",
      "name": "ctas",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "showAcceptOffer",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_displayInfo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_displayInfo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_displayInfo"
    },
    {
      "condition": "isPDPDesktopAggregationVariant",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespMarketplaceStickyHeader_displayInfo"
        }
      ]
    }
  ],
  "type": "ItemDisplayInfo",
  "abstractKey": null
};

(node as any).hash = "8cbf0df9a198a02d521e5d281ff83ba9";

export default node;
